module.exports = __webpack_public_path__ + "static/media/Group-course.5d8d33ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/HoleItem/Group-course.png
// module id = 226
// module chunks = 0